import get from 'lodash.get';
import { IAuthUser } from '../../../api/auth.api';

export const userTransformer = (user: Partial<IAuthUser>): IAuthUser => {
  return {
    username: get(user, 'username', ''),
    externalId: get(user, 'externalId', ''),
    isLoggedIn: get(user, 'isLoggedIn', false),
    role: get(user, 'role', 'SERVICE_PROVIDER'),
  };
};
